<template>
	<div class="modal-delTips">
		<slot name="tip-text"></slot>
		<el-row class="ok-btn">
			<el-button type="info" @click="cancelFn" round>cancle</el-button>
			<el-button type="primary" @click="confirmFn" round>confirm</el-button>
		</el-row>
	</div>
</template>

<script>
	export default {
		props: ['modalData'],
		methods: {
			cancelFn() {
				if (this.modalData.delType === 'dialog') {
					this.$store.commit('dialog/closeModalFn')
					return 
				}
				if (this.modalData.delType === 'chapter') {
					this.$store.commit('bookItem/closeModalFn')
					return 
				}
				if (this.modalData.delType === 'book') {
					this.$store.commit('home/closeModalFn')
				}
			},
			confirmFn() {
				if (this.modalData.delType === 'dialog') {
					this.$store.dispatch('dialog/delDialogFn', this.modalData.dialog)
					return 
				}
				if (this.modalData.delType === 'chapter') {
					// 删除章节
					this.postAxios('/h5/delWriterChapter', {
						book_id: this.modalData.book_id,
						chapter_number: this.modalData.chapter_number
					}).then((data) => {
							if (data.code === 200) {
								this.$store.commit('bookItem/delChapterFn', this.modalData.chapter_number)
							}
						}, (err) => {
						 // handle authorization error
					});	
					return 
				}
				if (this.modalData.delType === 'book') {
					this.postAxios('/h5/delWriterBook', {
						book_id:this.modalData.book_id
					}).then((data) => {
					  if (data.code === 200) {
						  this.$store.commit('home/delBookFn', this.modalData.book_id)
					  }
					}, (err) => {
					  // handle authorization error
					});
				}
			}
		}
	}
</script>

<style lang="scss">
	.modal-delTips {
		p.tips-text {
			font-size: 16px;
			line-height: 24px;
			color: #6f6f6f;
			text-align: center;
		}
		.ok-btn {
			.el-button.is-round {
				width: 90px;
				font-size: 16px;
				height: 40px;
				line-height: 40px;
				padding: 0;    
			}
			.el-button.el-button--primary {
				width: 90px!important;
				font-size: 16px!important;
				height: 40px!important;
				line-height: 40px!important;
			}
			.el-button + .el-button {
				margin-left: 20px;
			}
		}
	}
</style>
